import { cn } from '@/utils/cn';
import React from 'react';

function TextExtraSmall({ text, className, children }) {
  return (
    <p
      className={cn(
        'font-encode-sans text-left text-xss lg:text-xs text-coarse-wool',
        className,
      )}
    >
      {text}
      {children}
    </p>
  );
}

export default TextExtraSmall;
